module.exports = __webpack_public_path__ + "img/Gartenzimmer.81d8c078.jpg";